import React from "react";
import AnnouncementIcon from "../_shared/AnnouncementIcon";
import { TFunction } from "next-i18next";
import styles from "../../styles/components/skills-hub/ClosureNotice.module.scss";

// Shown on an open Skills Hub when no category has a class to book. It says
// only that nothing is open right now, not that the programme has ended: a
// gap between rounds is not a closure. The SOLS edu card below it is where to
// go next. Same notice styling as ClosureNotice, so the two read alike.
const NoClassesNotice = (props: Props) => {
  const { t } = props;

  return (
    <section className={styles.notice} aria-labelledby="skills-hub-no-classes">
      <div className={styles.icon}>
        <AnnouncementIcon />
      </div>
      <div className={styles.body}>
        <h2 id="skills-hub-no-classes">{t("no-classes-h2")}</h2>
        <p>{t("no-classes-p")}</p>
      </div>
    </section>
  );
};

interface Props {
  t: TFunction;
}

export default NoClassesNotice;
